import React from "react";
import { Select } from "antd";
import { useTranslation } from "react-i18next";

const AppboxLanguageSelect = (props) => {
    const { i18n, t } = useTranslation();

    const changeLanguage = (value) => {
        const selectedLanguage = value;
        i18n.changeLanguage(selectedLanguage);
        localStorage.setItem("language", selectedLanguage);
    };

    return (
        <Select onChange={changeLanguage} value={i18n.language} style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
            <Select.Option value="en">
                <div style={{ display: "flex", alignItems: "center", justifyContent: "center"}}>
                    <img src="/icons/eng.svg" alt="en" style={{ padding: "3px"}} />
                </div>
            </Select.Option>
            <Select.Option value="it">
                <div style={{ display: "flex", alignItems: "center", justifyContent: "center"}}>
                    <img src="/icons/ita.svg" alt="it" style={{ padding: "3px"}} />
                </div>
            </Select.Option>
        </Select>
    );
};

export { AppboxLanguageSelect };
